import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import './products.css';
import '../home/home.css';
import Swal from 'sweetalert2';

import productsBg from '../../assets/products-bg.png';

// Icons/Images
import billingImg from '../../assets/products/billing_illustration.png'; // Will replace with generation result if possible
import crmIcon from '../../assets/products/crm.png';
import ecommerceIcon from '../../assets/products/ecommerce.png';
import projectIcon from '../../assets/products/project.png';
import healthcareIcon from '../../assets/products/healthcare.png';
import supportIcon from '../../assets/products/support.png';
import fintechIcon from '../../assets/products/fintech.png';
import right from "../../assets/right.svg";
import mail from "../../assets/mail.svg";
import insuranceIcon from '../../assets/products/insurance.png';

// Video
import landvideo from "../../assets/sftdev.mp4"
import BASE_URL from "../../config.js";

// New Generated Illustration
// billing_illustration_1770189125498.png -> I'll use it if I can reference it correctly. 
// Since I can't easily guess the absolute path for future-proofing, I'll stick to variable names.
// For now, I'll use the existing ones but the design will handle them beautifully.

const products = [
  {
    id: 1,
    title: 'Billing Software',
    subtitle: 'Professional invoicing, stock control, and financial analytics for diverse business scales.',
    badge: 'ERP TOOL',
    image: billingImg,
    color: '#fff3e6'
  },
  {
    id: 2,
    title: 'Lead Management',
    subtitle: 'Maximize sales velocity with intelligent tracking and automated conversion workflows.',
    badge: 'CRM',
    image: crmIcon,
    color: '#fff3e6'
  },
  {
    id: 3,
    title: 'E-commerce Solutions',
    subtitle: 'High-performance digital storefronts built with security and user experience at the core.',
    badge: 'E-RETAIL',
    image: ecommerceIcon,
    color: '#f0fff4'
  },
  {
    id: 4,
    title: 'Builder Management',
    subtitle: 'Unified construction management platform for resource allocation and timeline tracking.',
    badge: 'BUILDER ERP',
    image: projectIcon,
    color: '#fdf2ff'
  },
  {
    id: 5,
    title: 'Hospital Management',
    subtitle: 'Integrated digital health platform optimizing hospital operations and patient care.',
    badge: 'HIMS',
    image: healthcareIcon,
    color: '#fff5f5'
  },
  {
    id: 6,
    title: 'Service Management',
    subtitle: 'Automated service desk and field workforce management for superior customer support.',
    badge: 'SERVICES',
    image: supportIcon,
    color: '#fff9e6'
  },
  {
    id: 7,
    title: 'Chit Management System',
    subtitle: 'Advanced automation suite for chit fund operations with secure transaction audits.',
    badge: 'FINANCE',
    image: fintechIcon,
    color: '#f1f5f9'
  },
   {
  id: 8,
  title: 'Insurance Management',
  subtitle: 'End-to-end insurance operations platform with policy administration, claims processing, and compliance-ready audit trails.',
  badge: 'INSURANCE',
  image: insuranceIcon,
  color: '#fff9e6'
}

];

const OurProducts = () => {
  const navigate = useNavigate();

  // Form State
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState('');
  const [message, setMessage] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [serviceError, setServiceError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [messageSuccess, setMessageSuccess] = useState('');

  const handleSelect = (event) => {
    setService(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setNameError(''); setEmailError(''); setPhoneError(''); setServiceError(''); setMessageError('');

    if (!name.trim()) { setNameError('Please enter your name.'); return; }
    if (!email.trim()) { setEmailError('Please enter your email.'); return; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) { setEmailError('Please enter a valid email address.'); return; }
    if (!phone.trim()) { setPhoneError('Please enter your phone number.'); return; }
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) { setPhoneError('Please enter a valid 10-digit phone number.'); return; }
    if (!service) { setServiceError('Please select a service.'); return; }
    if (!message.trim()) { setMessageError('Please enter your message.'); return; }

    const data = { name, email, phone, service, message };
    Swal.fire({ title: 'Sending...', text: 'Please wait...', allowOutsideClick: false, didOpen: () => { Swal.showLoading(); } });

    try {
      const response = await fetch(`${BASE_URL}/api/contact-form.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      const result = await response.json();
      if (result.status === 'success') {
        navigate('/thank-you');
        setName(''); setEmail(''); setPhone(''); setService(''); setMessage('');
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: result.message || 'Something went wrong.' });
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Submission Failed', text: 'Could not connect to the server.' });
    }
  };

  return (
    <div className='sde'>
      <Helmet>
        <title>Our Products | Vasmi Group - Innovative Enterprise Solutions</title>
        <meta name="description" content="Explore Vasmi Group's suite of enterprise products. Premium software solutions for billing, CRM, e-commerce, and more." />
      </Helmet>

      <div className='sde-one'>
        <video className="landvideo" autoPlay loop muted>
          <source src={landvideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="waviy">
          <span style={{ '--i': 1 }}>O</span>
          <span style={{ '--i': 2 }}>u</span>
          <span style={{ '--i': 3 }}>r</span>
          <span style={{ '--i': 4 }}> </span>
          <span style={{ '--i': 5 }} className="d i">P</span>
          <span style={{ '--i': 6 }} className="d">r</span>
          <span style={{ '--i': 7 }} className="d">o</span>
          <span style={{ '--i': 8 }} className="d">d</span>
          <span style={{ '--i': 9 }} className="d">u</span>
          <span style={{ '--i': 10 }} className="d">c</span>
          <span style={{ '--i': 11 }} className="d">t</span>
          <span style={{ '--i': 12 }} className="d">s</span>
        </div>
      </div>

      <div className="section-three" style={{ 
        backgroundImage: `url(${productsBg})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        backgroundAttachment: 'fixed',
        padding: '100px 0'
      }}>
        <h2 className="services-three" style={{ color: 'white' }}>Our Products</h2>
        <div className="sec-three-cards">
          {products.map((product) => (
            <div key={product.id} className="product-card-premium">
              <div className="card-top-illustration" style={{ backgroundColor: product.color }}>
                <div className="card-badge">{product.badge}</div>
                <img src={product.image} alt={product.title} />
              </div>
              <div className="card-body-content">
                <h3 className="card-title-premium">{product.title}</h3>
                <p className="card-desc-premium">{product.subtitle}</p>
                <button className="card-action-btn" onClick={() => navigate('/contact-us')}>
                  Explore Features
                  <img src={right} alt="arrow" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Form Section */}
      <div className="home-form">
        <div className="left-form-sec">
          <p className="home-left-form">Ready for a Demo?</p>
          <p className="lets-work-form">Let’s Transform Your Business</p>
          <form method="post" className="form-hom" onSubmit={handleSubmit}>
            <div className="inp-error">
              <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
              {nameError && <p className="error">{nameError}</p>}
            </div>
            <div className="inp-error">
              <input type="tel" placeholder="Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
              {phoneError && <p className="error">{phoneError}</p>}
            </div>
            <div className="inp-error">
              <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
              {emailError && <p className="error">{emailError}</p>}
            </div>
            <div className="inp-error">
              <select name="services" id="services" value={service} onChange={handleSelect}>
                <option value="">-- Select Product Interest --</option>
                {products.map((p) => (<option key={p.id} value={p.title}>{p.title}</option>))}
              </select>
              {serviceError && <p className="error">{serviceError}</p>}
            </div>
            <div className="inp-error">
              <textarea placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
              {messageError && <p className="error">{messageError}</p>}
            </div>
            <div className="successmeet">
              <button type="submit">Send Message</button>
              {messageSuccess && <p className="success">{messageSuccess}</p>}
            </div>
          </form>
        </div>
        <div className="right-form-sec">
          <p className="left-work-form">Consult with Experts</p>
          <p className="call-form-home">+91-9908033232</p>
          <p className="call-form-home">+91-95507 64936</p>
          <p className="mail-form-home">
            <img src={mail} alt="mail" /> info@vasmigroup.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default OurProducts;
